export const CAMERA_FOV = 50;
export const BOARD_DISTANCE = 8;
export const WINDOW_BAR_HEIGHT = 68;

export function getPanelViewport(width, height, inputMode = 'mouse') {
  if (inputMode === 'touch') {
    return { width: Math.round(Math.max(1, Math.min(1080, width - 24))), height: Math.round(Math.max(120, height - 170)) };
  }
  return { width: Math.round(Math.min(1080, width * 0.8)), height: Math.round(height * 0.68) };
}

export function getBoardLayout(width, height, inputMode = 'mouse') {
  const visibleHeight = 2 * Math.tan((CAMERA_FOV * Math.PI) / 360) * BOARD_DISTANCE;
  const panel = getPanelViewport(width, height, inputMode);
  const pixelSize = visibleHeight / Math.max(1, height);
  return {
    width: panel.width * pixelSize,
    height: panel.height * pixelSize,
    distance: BOARD_DISTANCE,
    centerY: visibleHeight * 0.045,
  };
}
